import React from "react";

const PaginationControls = ({
  page,
  totalPages,
  onPrev,
  onNext,
  isLoading = false,
  style = {},
}) => {
  if (!Number.isFinite(totalPages) || totalPages <= 1) {
    return null;
  }

  const isPrevDisabled = page <= 1 || isLoading;
  const isNextDisabled = page >= totalPages || isLoading;

  return (
    <div style={{ display: "flex", alignItems: "center", ...style }}>
      <button
        onClick={onPrev}
        disabled={isPrevDisabled}
        style={{
          padding: "4px 12px",
          borderRadius: 4,
          border: "1px solid #ccc",
          background: isPrevDisabled ? "#eee" : "#fff",
          cursor: isPrevDisabled ? "not-allowed" : "pointer",
        }}
      >
        Prev
      </button>

      <span style={{ margin: "0 8px" }}>
        Page {page} of {totalPages}
      </span>

      <button
        onClick={onNext}
        disabled={isNextDisabled}
        style={{
          padding: "4px 12px",
          borderRadius: 4,
          border: "1px solid #ccc",
          background: isNextDisabled ? "#eee" : "#fff",
          cursor: isNextDisabled ? "not-allowed" : "pointer",
        }}
      >
        Next
      </button>
    </div>
  );
};

export default PaginationControls;